export const TitleCompanyConstants = {
    CREATE_TITLECOMPANY_LOADING: "CREATE_TITLECOMPANY_LOADING",
    CREATE_TITLECOMPANY_SUCCESS: "CREATE_TITLECOMPANY_SUCCESS",
    CREATE_TITLECOMPANY_FAILURE: "CREATE_TITLECOMPANY_FAILURE",

    GET_TITLECOMPANY_LOADING: "GET_TITLECOMPANY_LOADING",
    GET_TITLECOMPANY_SUCCESS: "GET_TITLECOMPANY_SUCCESS",
    GET_TITLECOMPANY_FAILURE: "GET_TITLECOMPANY_FAILURE",

    GET_SELECTED_TITLECOMPANY_LOADING: "GET_SELECTED_TITLECOMPANY_LOADING",
    GET_SELECTED_TITLECOMPANY_SUCCESS: "GET_SELECTED_TITLECOMPANY_SUCCESS",
    GET_SELECTED_TITLECOMPANY_FAILURE: "GET_SELECTED_TITLECOMPANY_FAILURE",
  
}